import type { StepType, TaskStep, TaskStepType } from './types';

// Shared wire shape for task / work-order steps (the id field name differs per entity).
export interface StepDtoBase {
  sequence: number;
  stepNumber?: number | null;
  stepTypeID: number;
  stepTypeName?: string;
  description: string;
  isTracked: boolean;
  assayCode?: string | null;
  assayRequired?: boolean;
}

const toStepType = (name: string | undefined): TaskStepType =>
  (name ?? '').toLowerCase() === 'comment' ? 'Comment' : 'Step';

export const resolveStepTypeId = (type: TaskStepType, stepTypes: StepType[]): number => {
  const match = stepTypes.find((s) => s.stepTypeName.toLowerCase() === type.toLowerCase());
  if (match) return match.stepTypeID;
  return type === 'Comment' ? 2 : 1;
};

export const dtoToTaskStep = (dto: StepDtoBase, id: number | undefined): TaskStep => ({
  taskStepID: id,
  sequence: dto.sequence,
  stepNumber: dto.stepNumber ?? null,
  type: toStepType(dto.stepTypeName),
  description: dto.description ?? '',
  isTracked: dto.isTracked,
  assayCode: dto.assayCode ?? undefined,
  assayRequired: dto.assayRequired ?? false,
});
